import ClimateChangeV2Icon from 'static/icons/ClimateChangeV2.svg?react';
import OceanBiogeochemistryV2Icon from 'static/icons/OceanBiogeochemistryV2.svg?react';
import EnvironmentImpactAssessmentsV2Icon from 'static/icons/EnvironmentImpactAssessmentsV2.svg?react';
import MarineEcologyV2Icon from 'static/icons/MarineEcologyV2.svg?react';
import PhysicalOceanographyIcon from 'static/icons/PhysicalOceanography.svg?react';
import MarineSensingTechnologies from 'static/icons/MarineSensingTechnologies.svg?react';

// =============================================================================
export default function Icon(props: { index: number; width: string }) {
  const icons_style =
    props.width === 'mobile'
      ? {
          width: 48,
          height: 48
        }
      : {
          width: 124,
          height: 124
        };

  return [
    <ClimateChangeV2Icon style={icons_style} />,
    <OceanBiogeochemistryV2Icon style={icons_style} />,
    <EnvironmentImpactAssessmentsV2Icon style={icons_style} />,
    <MarineEcologyV2Icon style={icons_style} />,
    <PhysicalOceanographyIcon style={icons_style} />,
    <MarineSensingTechnologies style={icons_style} />
  ][props.index];
}
